const SyncroUsersImport = () => import('@/views/account/integrations/syncro/import/syncro-users-import-view.vue');
const SyncroCompaniesImport = () => import('@/views/account/integrations/syncro/import/syncro-companies-import-view.vue');
const SyncroContactsImport = () => import('@/views/account/integrations/syncro/import/syncro-contacts-import-view');

import store from '@/stores/index';

export default [
    {
        path: '/Integrations/Syncro/Manage/Users/Import',
        name: 'SyncroUsersImport',
        component: SyncroUsersImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Syncro/Manage/Users/Import',
        name: 'ClientSyncroUsersImport',
        component: SyncroUsersImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/Syncro/Manage/Companies/Import',
        name: 'SyncroCompaniesImport',
        component: SyncroCompaniesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Syncro/Manage/Companies/Import',
        name: 'ClientSyncroCompaniesImport',
        component: SyncroCompaniesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/Syncro/Manage/Contacts/Import',
        name: 'SyncroContactsImport',
        component: SyncroContactsImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Syncro/Manage/Contacts/Import',
        name: 'ClientSyncroContactsImport',
        component: SyncroContactsImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
]